module.exports = __webpack_public_path__ + "static/logo-b8dd2f3bde5cf54891f99ba5bf50b8c6.png";